export const convertToExternalCodes = (program: string): string => {
  switch (program.toUpperCase()) {
    case "ILC":
      return "ilsy";
    case "AY":
    case "MLY":
      return "aya";
    case "EXC":
      return "ils";
  }
  return program.toLowerCase();
};
